import { useMemo } from 'react';
import { formatArea, formatFloors } from '../../../utils/formatters';
import { useDeviceType } from '@cian/ui-kit';

interface IParams {
  area?: number;
  floorCount?: number;
  materials?: string;
}

export const useProjectParameters = ({ area, floorCount, materials }: IParams) => {
  const device = useDeviceType();

  return useMemo(() => {
    const list = [];

    if (area) {
      list.push(formatArea(area));
    }

    if (floorCount) {
      list.push(formatFloors(floorCount));
    }

    if (materials) {
      list.push(materials);
    }

    if (!list.length) {
      return;
    }

    return device === 'desktop' ? list.join(', ').toLowerCase() : list.join(' ･ ');
  }, [area, device, floorCount, materials]);
};
